var map = {
	"./SIDUVLOGO": 9,
	"./SIDUVLOGO.png": 9,
	"./authentication/authentication-bg": 10,
	"./authentication/authentication-bg.svg": 10,
	"./blog/blog-1": 11,
	"./blog/blog-1.jpg": 11,
	"./blog/blog-2": 12,
	"./blog/blog-2.jpg": 12,
	"./blog/blog-3": 13,
	"./blog/blog-3.jpg": 13,
	"./blog/blog-4": 14,
	"./blog/blog-4.jpg": 14,
	"./blog/blog-5": 15,
	"./blog/blog-5.jpg": 15,
	"./blog/blog-6": 16,
	"./blog/blog-6.jpg": 16,
	"./blog/blog_slide_01": 17,
	"./blog/blog_slide_01.jpg": 17,
	"./blog/blog_slide_02": 18,
	"./blog/blog_slide_02.jpg": 18,
	"./blog/blog_slide_03": 19,
	"./blog/blog_slide_03.jpg": 19,
	"./browser/chrome": 20,
	"./browser/chrome.png": 20,
	"./browser/mozilla": 21,
	"./browser/mozilla.png": 21,
	"./browser/opera": 22,
	"./browser/opera.png": 22,
	"./browser/safari": 23,
	"./browser/safari.png": 23,
	"./browser/windows": 24,
	"./browser/windows.png": 24,
	"./colorpicker/alpha": 25,
	"./colorpicker/alpha.png": 25,
	"./colorpicker/hue": 26,
	"./colorpicker/hue.png": 26,
	"./colorpicker/saturation": 27,
	"./colorpicker/saturation.png": 27,
	"./colorpicker/transparent": 28,
	"./colorpicker/transparent.png": 28,
	"./crypto/1": 29,
	"./crypto/1.png": 29,
	"./crypto/2": 30,
	"./crypto/2.png": 30,
	"./crypto/3": 31,
	"./crypto/3.png": 31,
	"./crypto/4": 32,
	"./crypto/4.png": 32,
	"./crypto/bcc": 33,
	"./crypto/bcc.png": 33,
	"./crypto/bcc_small": 34,
	"./crypto/bcc_small.png": 34,
	"./crypto/bitcoin": 35,
	"./crypto/bitcoin.png": 35,
	"./crypto/bitcoin_small": 36,
	"./crypto/bitcoin_small.png": 36,
	"./crypto/ethereum": 37,
	"./crypto/ethereum.png": 37,
	"./crypto/ethereum_small": 38,
	"./crypto/ethereum_small.png": 38,
	"./crypto/ripple": 39,
	"./crypto/ripple.png": 39,
	"./crypto/ripple_small": 40,
	"./crypto/ripple_small.png": 40,
	"./dashboard/cloud": 41,
	"./dashboard/cloud.svg": 41,
	"./ecommerce/logout": 42,
	"./ecommerce/logout.svg": 42,
	"./ecommerce/produc_slider_01": 43,
	"./ecommerce/produc_slider_01.png": 43,
	"./ecommerce/produc_slider_02": 44,
	"./ecommerce/produc_slider_02.png": 44,
	"./ecommerce/produc_slider_03": 45,
	"./ecommerce/produc_slider_03.png": 45,
	"./ecommerce/product_01": 46,
	"./ecommerce/product_01.svg": 46,
	"./ecommerce/product_02": 47,
	"./ecommerce/product_02.svg": 47,
	"./ecommerce/product_03": 48,
	"./ecommerce/product_03.svg": 48,
	"./ecommerce/product_04": 49,
	"./ecommerce/product_04.svg": 49,
	"./ecommerce/product_gallery_01": 50,
	"./ecommerce/product_gallery_01.jpg": 50,
	"./ecommerce/product_gallery_02": 51,
	"./ecommerce/product_gallery_02.jpg": 51,
	"./ecommerce/product_gallery_03": 52,
	"./ecommerce/product_gallery_03.jpg": 52,
	"./ecommerce/product_img_01": 53,
	"./ecommerce/product_img_01.jpg": 53,
	"./ecommerce/product_img_02": 54,
	"./ecommerce/product_img_02.jpg": 54,
	"./ecommerce/product_img_03": 55,
	"./ecommerce/product_img_03.jpg": 55,
	"./ecommerce/product_img_04": 56,
	"./ecommerce/product_img_04.jpg": 56,
	"./ecommerce/product_img_05": 57,
	"./ecommerce/product_img_05.jpg": 57,
	"./ecommerce/product_img_06": 58,
	"./ecommerce/product_img_06.jpg": 58,
	"./ecommerce/storage": 59,
	"./ecommerce/storage.png": 59,
	"./ecommerce/thankyou": 60,
	"./ecommerce/thankyou.svg": 60,
	"./ecommerce/wallet": 61,
	"./ecommerce/wallet.svg": 61,
	"./email/file-attached-1": 62,
	"./email/file-attached-1.jpg": 62,
	"./email/file-attached-2": 63,
	"./email/file-attached-2.jpg": 63,
	"./error/404": 64,
	"./error/404.svg": 64,
	"./error/coming-soon": 65,
	"./error/coming-soon.svg": 65,
	"./error/internal-server": 66,
	"./error/internal-server.svg": 66,
	"./error/maintenance": 67,
	"./error/maintenance.svg": 67,
	"./footer_2023": 68,
	"./footer_2023.png": 68,
	"./footer_nofondo": 69,
	"./footer_nofondo.png": 69,
	"./gallery/gallery-1": 70,
	"./gallery/gallery-1.jpg": 70,
	"./gallery/gallery-10": 71,
	"./gallery/gallery-10.jpg": 71,
	"./gallery/gallery-11": 72,
	"./gallery/gallery-11.jpg": 72,
	"./gallery/gallery-12": 73,
	"./gallery/gallery-12.jpg": 73,
	"./gallery/gallery-2": 74,
	"./gallery/gallery-2.jpg": 74,
	"./gallery/gallery-3": 75,
	"./gallery/gallery-3.jpg": 75,
	"./gallery/gallery-4": 76,
	"./gallery/gallery-4.jpg": 76,
	"./gallery/gallery-5": 77,
	"./gallery/gallery-5.jpg": 77,
	"./gallery/gallery-6": 78,
	"./gallery/gallery-6.jpg": 78,
	"./gallery/gallery-7": 79,
	"./gallery/gallery-7.jpg": 79,
	"./gallery/gallery-8": 80,
	"./gallery/gallery-8.jpg": 80,
	"./gallery/gallery-9": 81,
	"./gallery/gallery-9.jpg": 81,
	"./general/image-crop": 82,
	"./general/image-crop.jpg": 82,
	"./general/parent_01": 83,
	"./general/parent_01.png": 83,
	"./general/parent_02": 84,
	"./general/parent_02.png": 84,
	"./general/parent_03": 85,
	"./general/parent_03.png": 85,
	"./general/school_quote": 86,
	"./general/school_quote.svg": 86,
	"./general/signature": 87,
	"./general/signature.svg": 87,
	"./icon_menu": 88,
	"./icon_menu.png": 88,
	"./icons/camera": 89,
	"./icons/camera.svg": 89,
	"./icons/clock": 90,
	"./icons/clock.svg": 90,
	"./icons/digging": 91,
	"./icons/digging.svg": 91,
	"./icons/dollar": 92,
	"./icons/dollar-bubble": 93,
	"./icons/dollar-bubble.svg": 93,
	"./icons/dollar.svg": 92,
	"./icons/download": 94,
	"./icons/download.svg": 94,
	"./icons/file": 95,
	"./icons/file.svg": 95,
	"./icons/file_arrow_up": 96,
	"./icons/file_arrow_up.svg": 96,
	"./icons/file_attach": 97,
	"./icons/file_attach.svg": 97,
	"./icons/file_check": 98,
	"./icons/file_check.svg": 98,
	"./icons/file_check_line": 99,
	"./icons/file_check_line.svg": 99,
	"./icons/file_dollar": 100,
	"./icons/file_dollar.svg": 100,
	"./icons/graphic": 101,
	"./icons/graphic.svg": 101,
	"./icons/hammer_v2": 102,
	"./icons/hammer_v2.svg": 102,
	"./icons/hand_dollar": 103,
	"./icons/hand_dollar.svg": 103,
	"./icons/handshake": 104,
	"./icons/handshake.svg": 104,
	"./icons/home_line": 105,
	"./icons/home_line.svg": 105,
	"./icons/house": 106,
	"./icons/house.svg": 106,
	"./icons/icon": 107,
	"./icons/icon.svg": 107,
	"./icons/image": 108,
	"./icons/image.svg": 108,
	"./icons/info-circle": 109,
	"./icons/info-circle.svg": 109,
	"./icons/key": 110,
	"./icons/key.svg": 110,
	"./icons/key_line": 111,
	"./icons/key_line.svg": 111,
	"./icons/layers": 112,
	"./icons/layers.svg": 112,
	"./icons/line_chart": 113,
	"./icons/line_chart.svg": 113,
	"./icons/link": 114,
	"./icons/link.svg": 114,
	"./icons/logo_geo": 115,
	"./icons/logo_geo.svg": 115,
	"./icons/mail": 116,
	"./icons/mail.svg": 116,
	"./icons/man_group": 117,
	"./icons/man_group.svg": 117,
	"./icons/marker": 118,
	"./icons/marker.svg": 118,
	"./icons/money_bag": 119,
	"./icons/money_bag.svg": 119,
	"./icons/paperclip": 120,
	"./icons/paperclip.svg": 120,
	"./icons/pen-ruler": 121,
	"./icons/pen-ruler.svg": 121,
	"./icons/picture": 122,
	"./icons/picture.svg": 122,
	"./icons/pin": 123,
	"./icons/pin.svg": 123,
	"./icons/rectangle_list": 124,
	"./icons/rectangle_list.svg": 124,
	"./icons/registered": 125,
	"./icons/registered.svg": 125,
	"./icons/robot": 126,
	"./icons/robot.svg": 126,
	"./icons/tag": 127,
	"./icons/tag.svg": 127,
	"./icons/union": 128,
	"./icons/union.svg": 128,
	"./icons/user_plus": 129,
	"./icons/user_plus.svg": 129,
	"./icons/users-double": 130,
	"./icons/users-double.svg": 130,
	"./icons/world": 131,
	"./icons/world.svg": 131,
	"./icons/wrench": 132,
	"./icons/wrench.svg": 132,
	"./login_logo_ivba": 133,
	"./login_logo_ivba.png": 133,
	"./logo": 134,
	"./logo.svg": 134,
	"./logo2_BACREA": 135,
	"./logo2_BACREA.png": 135,
	"./logo_BACREA": 136,
	"./logo_BACREA.png": 136,
	"./logo_gob_prov": 137,
	"./logo_gob_prov.png": 137,
	"./logo_ins_vivienda": 138,
	"./logo_ins_vivienda.png": 138,
	"./logo_ivba": 139,
	"./logo_ivba.png": 139,
	"./pricing/pricing-premium": 140,
	"./pricing/pricing-premium.svg": 140,
	"./pricing/pricing-starter": 141,
	"./pricing/pricing-starter.svg": 141,
	"./pricing/pricing-ultimate": 142,
	"./pricing/pricing-ultimate.svg": 142,
	"./svg-icon/advanced": 143,
	"./svg-icon/advanced.svg": 143,
	"./svg-icon/apps": 144,
	"./svg-icon/apps.svg": 144,
	"./svg-icon/basic": 145,
	"./svg-icon/basic.svg": 145,
	"./svg-icon/chart": 146,
	"./svg-icon/chart.svg": 146,
	"./svg-icon/close": 147,
	"./svg-icon/close.svg": 147,
	"./svg-icon/collapse": 148,
	"./svg-icon/collapse.svg": 148,
	"./svg-icon/components": 149,
	"./svg-icon/components.svg": 149,
	"./svg-icon/dashboard": 150,
	"./svg-icon/dashboard.svg": 150,
	"./svg-icon/ecommerce": 151,
	"./svg-icon/ecommerce.svg": 151,
	"./svg-icon/email": 152,
	"./svg-icon/email.svg": 152,
	"./svg-icon/error": 153,
	"./svg-icon/error.svg": 153,
	"./svg-icon/form_elements": 154,
	"./svg-icon/form_elements.svg": 154,
	"./svg-icon/horizontal": 155,
	"./svg-icon/horizontal.svg": 155,
	"./svg-icon/icons": 156,
	"./svg-icon/icons.svg": 156,
	"./svg-icon/layouts": 157,
	"./svg-icon/layouts.svg": 157,
	"./svg-icon/logout": 158,
	"./svg-icon/logout.svg": 158,
	"./svg-icon/maps": 159,
	"./svg-icon/maps.svg": 159,
	"./svg-icon/notifications": 160,
	"./svg-icon/notifications.svg": 160,
	"./svg-icon/pages": 161,
	"./svg-icon/pages.svg": 161,
	"./svg-icon/search": 162,
	"./svg-icon/search.svg": 162,
	"./svg-icon/settings": 163,
	"./svg-icon/settings.svg": 163,
	"./svg-icon/tables": 164,
	"./svg-icon/tables.svg": 164,
	"./svg-icon/user": 165,
	"./svg-icon/user.svg": 165,
	"./svg-icon/verticle": 166,
	"./svg-icon/verticle.svg": 166,
	"./svg-icon/widgets": 167,
	"./svg-icon/widgets.svg": 167,
	"./svg-icon/widgets_old": 168,
	"./svg-icon/widgets_old.svg": 168,
	"./text_ministerio": 169,
	"./text_ministerio.png": 169,
	"./ui-alert/circles": 170,
	"./ui-alert/circles.png": 170,
	"./ui-alert/sweet-alert-bg": 171,
	"./ui-alert/sweet-alert-bg.png": 171,
	"./ui-cards/ui-cards-1": 172,
	"./ui-cards/ui-cards-1.jpg": 172,
	"./ui-cards/ui-cards-10": 173,
	"./ui-cards/ui-cards-10.jpg": 173,
	"./ui-cards/ui-cards-11": 174,
	"./ui-cards/ui-cards-11.jpg": 174,
	"./ui-cards/ui-cards-12": 175,
	"./ui-cards/ui-cards-12.jpg": 175,
	"./ui-cards/ui-cards-13": 176,
	"./ui-cards/ui-cards-13.jpg": 176,
	"./ui-cards/ui-cards-14": 177,
	"./ui-cards/ui-cards-14.jpg": 177,
	"./ui-cards/ui-cards-15": 178,
	"./ui-cards/ui-cards-15.jpg": 178,
	"./ui-cards/ui-cards-16": 179,
	"./ui-cards/ui-cards-16.jpg": 179,
	"./ui-cards/ui-cards-17": 180,
	"./ui-cards/ui-cards-17.jpg": 180,
	"./ui-cards/ui-cards-18": 181,
	"./ui-cards/ui-cards-18.jpg": 181,
	"./ui-cards/ui-cards-2": 182,
	"./ui-cards/ui-cards-2.jpg": 182,
	"./ui-cards/ui-cards-3": 183,
	"./ui-cards/ui-cards-3.jpg": 183,
	"./ui-cards/ui-cards-4": 184,
	"./ui-cards/ui-cards-4.jpg": 184,
	"./ui-cards/ui-cards-5": 185,
	"./ui-cards/ui-cards-5.jpg": 185,
	"./ui-cards/ui-cards-6": 186,
	"./ui-cards/ui-cards-6.jpg": 186,
	"./ui-cards/ui-cards-7": 187,
	"./ui-cards/ui-cards-7.jpg": 187,
	"./ui-cards/ui-cards-8": 188,
	"./ui-cards/ui-cards-8.jpg": 188,
	"./ui-cards/ui-cards-9": 189,
	"./ui-cards/ui-cards-9.jpg": 189,
	"./ui-carousel/ui-carousel-1": 190,
	"./ui-carousel/ui-carousel-1.jpg": 190,
	"./ui-carousel/ui-carousel-10": 191,
	"./ui-carousel/ui-carousel-10.jpg": 191,
	"./ui-carousel/ui-carousel-11": 192,
	"./ui-carousel/ui-carousel-11.jpg": 192,
	"./ui-carousel/ui-carousel-12": 193,
	"./ui-carousel/ui-carousel-12.jpg": 193,
	"./ui-carousel/ui-carousel-13": 194,
	"./ui-carousel/ui-carousel-13.jpg": 194,
	"./ui-carousel/ui-carousel-14": 195,
	"./ui-carousel/ui-carousel-14.jpg": 195,
	"./ui-carousel/ui-carousel-15": 196,
	"./ui-carousel/ui-carousel-15.jpg": 196,
	"./ui-carousel/ui-carousel-16": 197,
	"./ui-carousel/ui-carousel-16.jpg": 197,
	"./ui-carousel/ui-carousel-17": 198,
	"./ui-carousel/ui-carousel-17.jpg": 198,
	"./ui-carousel/ui-carousel-18": 199,
	"./ui-carousel/ui-carousel-18.jpg": 199,
	"./ui-carousel/ui-carousel-2": 200,
	"./ui-carousel/ui-carousel-2.jpg": 200,
	"./ui-carousel/ui-carousel-3": 201,
	"./ui-carousel/ui-carousel-3.jpg": 201,
	"./ui-carousel/ui-carousel-4": 202,
	"./ui-carousel/ui-carousel-4.jpg": 202,
	"./ui-carousel/ui-carousel-5": 203,
	"./ui-carousel/ui-carousel-5.jpg": 203,
	"./ui-carousel/ui-carousel-6": 204,
	"./ui-carousel/ui-carousel-6.jpg": 204,
	"./ui-carousel/ui-carousel-7": 205,
	"./ui-carousel/ui-carousel-7.jpg": 205,
	"./ui-carousel/ui-carousel-8": 206,
	"./ui-carousel/ui-carousel-8.jpg": 206,
	"./ui-carousel/ui-carousel-9": 207,
	"./ui-carousel/ui-carousel-9.jpg": 207,
	"./ui-images/image-center": 208,
	"./ui-images/image-center.jpg": 208,
	"./ui-images/image-circle": 209,
	"./ui-images/image-circle.jpg": 209,
	"./ui-images/image-left": 210,
	"./ui-images/image-left.jpg": 210,
	"./ui-images/image-responsive": 211,
	"./ui-images/image-responsive.jpg": 211,
	"./ui-images/image-right": 212,
	"./ui-images/image-right.jpg": 212,
	"./ui-images/image-rounded": 213,
	"./ui-images/image-rounded.jpg": 213,
	"./ui-images/image-thumbnail": 214,
	"./ui-images/image-thumbnail.jpg": 214,
	"./ui-onboard/customisable": 215,
	"./ui-onboard/customisable.svg": 215,
	"./ui-onboard/easily-editable-code": 216,
	"./ui-onboard/easily-editable-code.svg": 216,
	"./ui-onboard/responsive": 217,
	"./ui-onboard/responsive.svg": 217,
	"./ui-onboard/unboard": 218,
	"./ui-onboard/unboard.svg": 218,
	"./ui-onboard/unique-widgets": 219,
	"./ui-onboard/unique-widgets.svg": 219,
	"./users/boy": 220,
	"./users/boy.svg": 220,
	"./users/girl": 221,
	"./users/girl.svg": 221,
	"./users/men": 222,
	"./users/men.svg": 222,
	"./users/profile": 223,
	"./users/profile.svg": 223,
	"./users/women": 224,
	"./users/women.svg": 224
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 364;